module.exports = "/fonts/vendor/@fortawesome/fontawesome-free/webfa-brands-400.eot?877baf6278a6f1506a07afd23b334f47";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fortawesome/fontawesome-free/webfonts/fa-brands-400.eot
// module id = E25J
// module chunks = 29